<template>
	<div class="page">
		<!-- your page -->
		<div class="pubHead">
			<Head></Head>
		</div>
		<div class="container">
			<div class="cont">
				<div class="back">
					<img src="../../assets/login/login.png" alt="">
				</div>
				<div class="formBox">
					<div class="fixation">
						<div class="formArea">
							<div class="tab">
								<div class="item"><span :id="select1" :data-id="1" @click="switchBtn">账号登录</span></div>
								<div class="item"><span :id="select2" :data-id="2" @click="switchBtn">立即注册</span></div>
							</div>
							<div class="form" v-if="formNumber==1">
								<div class="line">
									<el-input placeholder="请输入手机号" v-model="phone">
										<i slot="prefix" class="el-input__icon el-icon-mobile-phone"></i>
									</el-input>
								</div>
								<div class="line">
									<el-input type="password" placeholder="请输入密码" v-model="password">
										<i slot="prefix" class="el-input__icon el-icon-lock"></i>
									</el-input>
								</div>
								<div class="line">
									<el-button type="primary" @click="login">登录</el-button>
								</div>
								<div class="line goOther" :data-id="3" @click="switchBtn">
									手机验证登录
								</div>
							</div>
							<div class="form" v-if="formNumber==2">
								<div class="line">
									<el-input placeholder="请输入用户名" v-model="username">
										<i slot="prefix" class="el-input__icon el-icon-user"></i>
									</el-input>
								</div>
								<div class="line">
									<el-input placeholder="请输入手机号" v-model="phone">
										<i slot="prefix" class="el-input__icon el-icon-mobile-phone"></i>
									</el-input>
								</div>
								<div class="line">
									<el-input type="password" placeholder="请设置密码" v-model="password">
										<i slot="prefix" class="el-input__icon el-icon-lock"></i>
									</el-input>
								</div>
								<!-- <div class="line">
									<el-input class="code" placeholder="请输入验证码" v-model="code">
										<i slot="prefix" class="el-input__icon el-icon-key"></i>
									</el-input>
									<button class="send" v-if="sendShow" @click="sendCode('reg')">发送验证码</button>
									<button class="noSend" v-if="!sendShow">{{second}}秒后可重发</button>
								</div> -->
								<div class="line">
									<el-button type="primary" @click="primary('reg')">注册</el-button>
								</div>
							</div>
							<div class="form" v-if="formNumber==3">
								<div class="line">
									<el-input placeholder="请输入手机号" v-model="phone">
										<i slot="prefix" class="el-input__icon el-icon-mobile-phone"></i>
									</el-input>
								</div>
								<div class="line">
									<el-input class="code" placeholder="请输入验证码" v-model="code">
										<i slot="prefix" class="el-input__icon el-icon-key"></i>
									</el-input>
									<button class="send" v-if="sendShow" @click="sendCode('log')">发送验证码</button>
									<button class="noSend" v-if="!sendShow">{{second}}秒后可重发</button>
								</div>
								<div class="line">
									<el-button type="primary" @click="primary('codeLogin')">登录</el-button>
								</div>
								<div class="line goOther" :data-id="1" @click="switchBtn">
									账号密码登录
								</div>
							</div>
						</div>
					</div>
				</div>
			</div>
		</div>
		<div class="pubFoot">
			<Foot></Foot>
		</div>
	</div>
</template>

<script>
	// your script
	import Head from '../../components/head.vue'
	import Foot from '../../components/foot.vue'
	export default {
		name: 'login',
		components:{
			Head,Foot
		},
		data(){
			return {
				formNumber:1,
				select1:"select",
				select2:"",
				phone:"",
				password:"",
				username:"",
				code:"",
				second:60,
				sendShow:true
			}
		},
		methods:{
			switchBtn(e){
				//切换登录、验证码登录、注册
				var id = e.target.dataset.id
				this.phone="",
				this.password="",
				this.username="",
				this.code=""
				if(id==1){
					this.formNumber=1
					this.select1="select"
					this.select2=""
				}else if(id==2){
					this.formNumber=2
					this.select1=""
					this.select2="select"
				}else if(id==3){
					this.formNumber=3
				}
			},
			sendCode(type){
				//获取验证码
				var phone = this.phone
				var data 
				if(type=="reg"){
					data = {
						"mobile":phone,
						"code":"reg",
						"method":"user.sms"
					}
				}else if(type=='log'){
					data = {
						"mobile":phone,
						"code":"login",
						"method":"user.sms"
					}
				}
				this.second=60
				var that = this
				this.sendShow = false
				this.request(data,function(res){
					if(res.status){
						that.globalTest('user.sms','success','发送验证码成功')
						var interval = setInterval(function(){
							var second = that.second
							second--
							if(second>0){
								that.second = second
								that.sendShow = false
							}else{
								that.sendShow = true
								clearInterval(interval)
							}
						},1000)
					}else{
						that.globalTest('user.sms','error',res.msg,res.data)
					}
				})
			},
			primary(type){
				//确认注册
				var data
				if(type=='reg'){
					data = {
						"mobile":this.phone,
						"code":this.code,
						"password":this.password,
						"method":"user.smslogin",
						"username":this.username
					}
				}else{
					data = {
						mobile: this.phone,
						code: this.code,
						invitecode: '',
						method: "user.smslogin"
					}
				}
				var that = this
				this.request(data,function(res){
					if(res.status){
						type=='reg'?that.globalTest('user.smslogin','success','注册成功！'):that.globalTest('user.smslogin','success','登陆成功！')
						var token = res.data
						localStorage.setItem('token',token)
						that.$router.push({path:'/',query:{}})
					}else{
						that.globalTest('user.smslogin','error',res.msg,res.data)
					}
				})
			},
			login(){
				//手机号密码登录
				var data = {
					"mobile":this.phone,
					"password":this.password,
					"method":"user.login"
				}
				var that = this
				this.request(data,function(res){
					if(res.status){
						that.globalTest('user.login','success','登陆成功！')
						var token = res.data
						localStorage.setItem('token',token)
						that.$router.push({path:'/',query:{}})
					}else{
						that.globalTest('user.login','error',res.msg,res.data)
					}
				})
			}
		},
		beforeCreate: function() {
			//生命周期 -- 组件实例刚被创建，组件属性计算之前，如DATA属性等
		},
		created: function() {
			//生命周期 -- 组件实例创建完成，属性已绑定，但DOM还未生成，$el属性还不存在
		},
		beforeMount: function() {
			//模板编译/挂载之前
		},
		mounted: function() {
			//模板编译/挂载之后
			this.formNumber = this.$route.query.type
			this.formNumber==1?(this.select1="select",this.select2=""):(this.select1="",this.select2="select")
		},
		beforeUpdate: function() {
			//组件更新之前
		},
		updated: function() {
			//组件更新之后
		},
		activated: function() {
			// for keep-alive，组件被激活时调用
		},
		deactivated: function() {
			// for keep-alive，组件被移除时调用
		},
		beforeDestory: function() {
			// 组件销毁调用
		},
		destoryed: function() {
			// 组件销毁后调用
		}
	}
</script>

<style scoped>
	/* your css */
	.pubHead{
		width: 100%;
		height: 160px;
		position: fixed;
		z-index: 2;
		left: 0px;
		top: 0px;
	}
	.container{
		width: 100%;
		height: 100%;
		position: fixed;
		z-index: 1;
		left: 0px;
		top: 0px;
		padding-top: 160px;
		padding-bottom: 300px;
		box-sizing: border-box;
	}
	.cont{
		width: 100%;
		height: 100%;
		position: relative;
	}
	.back{
		width: 100%;
		height: 100%;
		overflow: hidden;
	}
	.formBox{
		position: absolute;
		left: 0px;
		top: 0px;
		width: 100%;
		height: 100%;
	}
	.fixation{
		position: relative;
	}
	.formArea{
		width: 300px;
		height: 330px;
		background: #FFFFFF;
		position: absolute;
		right: 0px;
		top: 50%;
		margin-top: -165px;
		border-radius: 10px;
	}
	.tab{
		width: 100%;
		height: 50px;
	}
	.tab .item{
		width: 50%;
		height: 100%;
		float: left;
		text-align: center;
		line-height: 50px;
	}
	.tab .item span{
		display: block;
		height: 100%;
		margin: 0 auto;
		width: 80px;
	}
	#select{
		border-bottom: 2px solid #036DEE;
		box-sizing: border-box;
	}
	.form{
		width: 100%;
		height: 300px;
		padding: 0px 20px;
		box-sizing: border-box;
	}
	.line{
		width: 100%;
		height: 40px;
		margin-top: 20px;
	}
	.code{
		width: 70%;
	}
	.send{
		width: 30%;
		height: 100%;
		background: none;
		border: none;
		color: #036DEE;
	}
	.noSend{
		width: 30%;
		height: 100%;
		background: #E3E3E3;
		border: none;
		color: #838383;
		font-size: 12px;
	}
	.formTitle{
		text-align: center;
		line-height: 14px;
		font-weight: 600;
	}
	.goOther{
		text-align: right;
		color: #036DEE;
		font-size: 12px;
		cursor: pointer;
	}
	.el-button--primary{
		width: 100%;
	}
	.pubFoot{
		width: 100%;
		height: 300px;
		position: fixed;
		z-index: 2;
		left: 0px;
		bottom: 0px;
	}
</style>
